"use strict";
import { InterfaceElementName } from "@uniswap/analytics-events";
import Column from "components/deprecated/Column";
import { AutoRow } from "components/deprecated/Row";
import { useDisableNFTRoutes } from "hooks/useDisableNFTRoutes";
import { atom, useAtom } from "jotai";
import styled, { useTheme } from "lib/styled-components";
import { Suspense, lazy, useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { ThemedText } from "theme/components";
import { Loader } from "ui/src/loading/Loader";
import { breakpoints } from "ui/src/theme";
const Tokens = lazy(() => import("components/AccountDrawer/MiniPortfolio/Tokens/TokensTab"));
const lastPageAtom = atom(0);
const Wrapper = styled(Column)`
  margin-top: 28px;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 12px;

  @media screen and (max-width: ${breakpoints.md}px) {
    margin-bottom: 48px;
  }

  .portfolio-row-wrapper {
    &:hover {
      background: ${({ theme }) => theme.deprecated_hoverDefault};
    }
  }
`;
const Nav = styled(AutoRow)`
  gap: 20px;
`;
const NavItem = styled(ThemedText.SubHeader)`
  align-items: center;
  color: ${({ theme, active }) => active ? theme.neutral1 : theme.neutral2};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  transition: ${({ theme }) => `${theme.transition.duration.medium} ${theme.transition.timing.ease} color`};

  &:hover {
    color: ${({ theme, active }) => active ? theme.neutral1Hovered : theme.neutral2Hovered};
  }
`;
const PageWrapper = styled.div`
  border-radius: 12px;
  margin-right: -16px;
  margin-left: -16px;
  width: calc(100% + 32px);
  flex: 1;
`;
const Pages = [
  {
    title: <Trans i18nKey="common.tokens" />,
    key: "tokens",
    component: () => <Suspense fallback={<Loader.Box />}>
        <Tokens />
      </Suspense>,
    loggingElementName: InterfaceElementName.MINI_PORTFOLIO_TOKENS_TAB
  }
];
export default function MiniPortfolio({ account }) {
  const theme = useTheme();
  const [lastPage, setLastPage] = useAtom(lastPageAtom);
  const [currentPage, setCurrentPage] = useState(lastPage);
  useEffect(() => void setLastPage(currentPage), [currentPage, setLastPage]);
  const shouldDisableNFTRoutes = useDisableNFTRoutes();
  const { component: Page, key: currentKey } = Pages[currentPage];
  return <Wrapper>
      <Nav data-testid="mini-portfolio-navbar">
        {Pages.map(({ title, loggingElementName, key }, index) => {
    if (shouldDisableNFTRoutes && loggingElementName.includes("nft")) {
      return null;
    }
    const handleNavItemClick = () => {
      setCurrentPage(index);
    };
    return <NavItem
      onClick={handleNavItemClick}
      active={currentPage === index}
      key={key}
      data-testid={loggingElementName}
    >
              <span>{title}</span>
            </NavItem>;
  })}
      </Nav>
      <PageWrapper data-testid="mini-portfolio-page">
        <Page account={account} />
      </PageWrapper>
    </Wrapper>;
}
